<template>
  <AppView title="會員註冊" :footerShow="false">
    <main class="min-h-app bg-gray-50 pb-24">
      <section class="border-b border-gray-100 bg-white px-5 py-6">
        <p class="text-xs font-medium text-gray-400">新會員</p>
        <h1 class="mt-2 text-xl font-bold text-gray-900">建立會員帳號</h1>
        <p class="mt-2 text-sm leading-6 text-gray-500">
          完成電話認證後即可購買商品，訂單紀錄會保存到會員帳號。
        </p>
      </section>

      <section class="mt-2 border-y border-gray-100 bg-white px-5 py-5">
        <h2 class="mb-5 text-sm font-bold text-gray-900">會員資料</h2>
        <RegisterForm @login="submit" :disabled="posting" />
      </section>
    </main>
  </AppView>
</template>

<script>
import RegisterForm from "@/components/forms/RegisterForm.vue";
export default {
  components: { RegisterForm },
  auth: "guest",
  head() {
    return {
      title: `${this.$store.getters['app/info']?.name || process.env.APP_NAME}-會員註冊`,
    };
  },
  data() {
    const user = this.$auth.user?.data;
    return {
      posting: false, // 提交中
    };
  },

  methods: {
    submit(data) {
      // 當在提交中，不再提交
      if (this.posting) return;
      this.posting = true;
      this.$auth
        .loginWith("local", { data: data })
        .then(() => {
          if (this.$track) {
            this.$track.event("login", {
              method: "local",
              source: "sign_up",
              country_code: data?.country_code,
            });
          }
        })
        .catch((err) => {
          if (this.errors.user) {
            this.$loader.error(this.errors.user[0]);
          }
        })
        .finally(() => {
          this.posting = false;
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
